import dayjs from 'dayjs'
// import { STORAGE_NUM, LOAD_AND_UNLOAD_NUM } from '../../../constant/constant.js'
import { companyAdvanceConfig, logicalWhAdvanceConfig } from '../../../constant/advanceConfig.js'

export const dayConfig = {
    // configuration: true,
    searchList: {
        searchTxt: [
            {
                name: '月份',
                value: 'assessmentMonthList',
                type: 'time',
                timeType: 'monthrange',
                format: 'yyyy-MM',
                startPlaceholder: '开始月份',
                endPlaceholder: '结束月份',
                unfold: true,
                span: 5,
            },
            {
                name: '供应商',
                value: 'supplierName',
                advanceLabel: '供应商弹出框',
                type: 'advance',
                multiple: true,
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierNameCn', value: '供应商名称' },
                ],
                tableConfig: [
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierNameCn', value: '供应商名称' },
                ],
                cbParams: [
                    'supplierCode#supplierCode',
                    'supplierNameCn#supplierName',
                    // 'supplierType#supplierType',
                    // 'propertyNature#property',
                ],
                multipleTableColumn: { prop: 'supplierNameCn', value: '供应商名称' },
                // extraParams: {
                //     businessTypeList: [STORAGE_NUM, LOAD_AND_UNLOAD_NUM],
                // },
                advanceUrl: `/supplier/supplierInfo/queryList`,
                prefix: 'api-srm-web',
                method: 'post',
                notFetchOnShow: true,
                queryConditionRequired: true,
                unfold: true,
                span: 4,
            },
            {
                ...companyAdvanceConfig,
                unfold: true,
                span: 4,
            },
            {
                ...logicalWhAdvanceConfig,
                extraParams: { cdwhIsStop: '0' },
                multiple: true,
                multipleTableColumn: { prop: 'cdwhName', value: '逻辑仓名称' },
                unfold: true,
                span: 4,
            },
            {
                name: '分类',
                value: 'complaintCategory',
                type: 'select',
                optionNum: 'SRM_COMPLAINT_CATEGORY',
                unfold: true,
                span: 4,
            },
            {
                name: '创建时间',
                value: 'createTimeArr',
                type: 'time',
                startPlaceholder: '创建开始时间',
                endPlaceholder: '创建结束时间',
                timeNum: 90,
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(6, 'd').toDate()
                                const end = dayjs().endOf('day').toDate()
                                picker.$emit('pick', [start, end])
                            },
                        },
                        {
                            text: '最近一个月',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(30, 'd').toDate()
                                const end = dayjs().endOf('day').toDate()
                                picker.$emit('pick', [start, end])
                            },
                        },
                        {
                            text: '最近三个月',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(90, 'd').toDate()
                                const end = dayjs().endOf('day').toDate()
                                picker.$emit('pick', [start, end])
                            },
                        },
                    ],
                },
                unfold: true,
                span: 6,
            },
        ],
        unfoldState: false,
        advancedBtn: false,
    },
    table: {
        // switchType: true,
        // tableCut: false,
        // clickState: false,
        // selectBtn: true,
        height: 'calc(100vh - 288px)',
        columns: [
            {
                label: '考核月份',
                prop: 'assessmentMonth',
                width: '100px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '供应商名称',
                prop: 'supplierName',
                width: '140px',
            },
            {
                label: '分公司',
                prop: 'companyName',
                width: '140px',
            },
            {
                label: '逻辑仓',
                prop: 'logicalWarehouseName',
                width: '200px',
            },
            {
                label: '分类',
                prop: 'complaintCategory',
                type: 'select',
                optionNum: 'SRM_COMPLAINT_CATEGORY',
                width: '100px',
            },
            {
                label: '投诉内容',
                prop: 'complaintContent',
                width: '150px',
            },
            {
                label: '投诉人',
                prop: 'mipName',
                width: '100px',
            },
            {
                label: '投诉电话',
                prop: 'complainantPhone',
                width: '100px',
            },
            {
                label: '备注',
                prop: 'remark',
                width: '150px',
            },
            {
                label: '创建人',
                prop: 'createUserName',
                width: '100px',
            },
            {
                label: '创建时间',
                prop: 'createTime',
                width: '160px',
            },
            {
                label: '更新人',
                prop: 'updateUserName',
                width: '100px',
            },
            {
                label: '更新时间',
                prop: 'updateTime',
                width: '160px',
            },
        ],
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
    },
}

export const monthConfig = {
    // configuration: true,
    searchList: {
        searchTxt: [
            {
                name: '月份',
                value: 'assessmentMonthList',
                type: 'time',
                timeType: 'monthrange',
                format: 'yyyy-MM',
                startPlaceholder: '开始月份',
                endPlaceholder: '结束月份',
                unfold: true,
                span: 5,
            },
            {
                name: '供应商',
                value: 'supplierName',
                advanceLabel: '供应商弹出框',
                type: 'advance',
                multiple: true,
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierNameCn', value: '供应商名称' },
                ],
                tableConfig: [
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierNameCn', value: '供应商名称' },
                ],
                cbParams: [
                    'supplierCode#supplierCode',
                    'supplierNameCn#supplierName',
                    // 'supplierType#supplierType',
                    // 'propertyNature#property',
                ],
                multipleTableColumn: { prop: 'supplierNameCn', value: '供应商名称' },
                // extraParams: {
                //     businessTypeList: [STORAGE_NUM, LOAD_AND_UNLOAD_NUM],
                // },
                advanceUrl: `/supplier/supplierInfo/queryList`,
                prefix: 'api-srm-web',
                method: 'post',
                notFetchOnShow: true,
                queryConditionRequired: true,
                unfold: true,
                span: 4,
            },
            {
                ...companyAdvanceConfig,
                unfold: true,
                span: 4,
            },
            {
                name: '创建时间',
                value: 'createTimeArr',
                type: 'time',
                startPlaceholder: '创建开始时间',
                endPlaceholder: '创建结束时间',
                timeNum: 90,
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(6, 'd').toDate()
                                const end = dayjs().endOf('day').toDate()
                                picker.$emit('pick', [start, end])
                            },
                        },
                        {
                            text: '最近一个月',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(30, 'd').toDate()
                                const end = dayjs().endOf('day').toDate()
                                picker.$emit('pick', [start, end])
                            },
                        },
                        {
                            text: '最近三个月',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(90, 'd').toDate()
                                const end = dayjs().endOf('day').toDate()
                                picker.$emit('pick', [start, end])
                            },
                        },
                    ],
                },
                unfold: true,
                span: 6,
            },
        ],
        unfoldState: false,
        advancedBtn: false,
    },
    table: {
        // switchType: true,
        // tableCut: false,
        // clickState: false,
        // selectBtn: true,
        height: 'calc(100vh - 250px)',
        columns: [
            {
                label: '考核月份',
                prop: 'assessmentMonth',
                width: '100px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '供应商名称',
                prop: 'supplierName',
                width: '140px',
            },
            {
                label: '分公司',
                prop: 'companyName',
                width: '140px',
            },

            {
                label: '考核事项',
                prop: 'assessmentItem',
                width: '100px',
            },
            {
                label: '问题维度',
                prop: 'problemDimension',
                type: 'select',
                optionNum: 'SRM_PROBLEM_DIMENSION',
                width: '100px',
            },
            {
                label: '考核分值',
                prop: 'assessmentScore',
                width: '100px',
            },
            {
                label: '实际分值',
                prop: 'actualScore',
                width: '100px',
            },
            {
                label: '评价人',
                prop: 'mipName',
                width: '100px',
            },
            {
                label: '备注',
                prop: 'remark',
                width: '150px',
            },
            {
                label: '创建人',
                prop: 'createUserName',
                width: '100px',
            },
            {
                label: '创建时间',
                prop: 'createTime',
                width: '160px',
            },
            {
                label: '更新人',
                prop: 'updateUserName',
                width: '100px',
            },
            {
                label: '更新时间',
                prop: 'updateTime',
                width: '160px',
            },
        ],
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
    },
}

export const yearConfig = {
    // configuration: true,
    searchList: {
        searchTxt: [
            {
                name: '年份',
                value: 'assessmentYearList',
                type: 'time',
                timeType: 'years',
                format: 'yyyy',
                placeholder: '年份',
                unfold: true,
                span: 5,
            },
            {
                name: '供应商',
                value: 'supplierName',
                advanceLabel: '供应商弹出框',
                type: 'advance',
                multiple: true,
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierNameCn', value: '供应商名称' },
                ],
                tableConfig: [
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierNameCn', value: '供应商名称' },
                ],
                cbParams: [
                    'supplierCode#supplierCode',
                    'supplierNameCn#supplierName',
                    // 'supplierType#supplierType',
                    // 'propertyNature#property',
                ],
                multipleTableColumn: { prop: 'supplierNameCn', value: '供应商名称' },
                // extraParams: {
                //     businessTypeList: [STORAGE_NUM, LOAD_AND_UNLOAD_NUM],
                // },
                advanceUrl: `/supplier/supplierInfo/queryList`,
                prefix: 'api-srm-web',
                method: 'post',
                notFetchOnShow: true,
                queryConditionRequired: true,
                unfold: true,
                span: 4,
            },
            {
                ...companyAdvanceConfig,
                unfold: true,
                span: 4,
            },
            {
                name: '创建时间',
                value: 'createTimeArr',
                type: 'time',
                startPlaceholder: '创建开始时间',
                endPlaceholder: '创建结束时间',
                timeNum: 90,
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(6, 'd').toDate()
                                const end = dayjs().endOf('day').toDate()
                                picker.$emit('pick', [start, end])
                            },
                        },
                        {
                            text: '最近一个月',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(30, 'd').toDate()
                                const end = dayjs().endOf('day').toDate()
                                picker.$emit('pick', [start, end])
                            },
                        },
                        {
                            text: '最近三个月',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(90, 'd').toDate()
                                const end = dayjs().endOf('day').toDate()
                                picker.$emit('pick', [start, end])
                            },
                        },
                    ],
                },
                unfold: true,
                span: 6,
            },
        ],
        unfoldState: false,
        advancedBtn: false,
    },
    table: {
        // switchType: true,
        // tableCut: false,
        // clickState: false,
        // selectBtn: true,
        height: 'calc(100vh - 250px)',
        columns: [
            {
                label: '考核月份',
                prop: 'assessmentMonth',
                width: '100px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '供应商名称',
                prop: 'supplierName',
                width: '140px',
            },
            {
                label: '分公司',
                prop: 'companyName',
                width: '140px',
            },
            {
                label: '考核年份',
                prop: 'assessmentYear',
                width: '100px',
            },
            {
                label: '评价内容',
                prop: 'complaintContent',
                width: '150px',
            },
            {
                label: '年度评价得分',
                prop: 'annualEvaluationScore',
                width: '100px',
            },
            {
                label: '月度评价平均分*70%',
                prop: 'monthlyAvgScoreWeighted',
                width: '150px',
            },
            {
                label: '评价人',
                prop: 'mipName',
                width: '100px',
            },
            {
                label: '备注',
                prop: 'remark',
                width: '150px',
            },
            {
                label: '创建人',
                prop: 'createUserName',
                width: '100px',
            },
            {
                label: '创建时间',
                prop: 'createTime',
                width: '160px',
            },
            {
                label: '更新人',
                prop: 'updateUserName',
                width: '100px',
            },
            {
                label: '更新时间',
                prop: 'updateTime',
                width: '160px',
            },
        ],
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
    },
}
